import { z } from 'zod';

export type UpdateImagePayload = z.infer<typeof updateImagePayloadSchema>;

export const updateImagePayloadSchema = z.object({
  filename: z.string().min(1),
});
